export type ProtocolT = string | "http" | "https";

export const enum PROTOCOL {
  HTTP = "http",
  HTTPS = "https",
}
